import { render, staticRenderFns } from "./FundingAssessmentsReview.vue?vue&type=template&id=5ea191f2&"
import script from "./FundingAssessmentsReview.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports